/**
 * Alerts
 */

/** Modal code */
let modal;

//Function to close the modal
function closeModal() {
	if(modal){
		$(modal).modal('hide');  //Hides the modal
		$(modal).remove();
		//let garbage = document.querySelector('.modal')  //Grabs any remaining tags with class modal
		//garbage.remove()  //removes remaining tags completely
	}
};

//Function to call the normal 2 button modal
function normalModal() {
	//Get active order ID
	let activeOrder = $('#active_order').attr('data-order_id');
	//Grab div element to insert modal before
	let demoContainer= document.querySelector("#app");

	//The following creates the modal
	modal = document.createElement('div');
	modal.classList.add('modal');
	modal.classList.add('fade');
	modal.setAttribute('id', 'normalModal');
	modal.setAttribute('tabindex', '-1');
	modal.setAttribute('role', 'dialog');
	modal.setAttribute('aria-labelledby', 'normalModalLabel');

	let modalDialogArea = document.createElement('div');
	modalDialogArea.classList.add('modal-dialog');
	modalDialogArea.classList.add('modal-dialog-centered');
	modalDialogArea.classList.add('modal-sm');
	modalDialogArea.setAttribute('role', 'document');
	modal.appendChild(modalDialogArea);

	let modalContent = document.createElement('div');
	modalContent.classList.add('modal-content');
	modalDialogArea.appendChild(modalContent);
	//Modal header area
	let modalHeader = document.createElement('div');
	modalHeader.classList.add('modal-header');
	modalContent.appendChild(modalHeader);
	//Modal header content
	let modalTitle = document.createElement('h5');
	modalTitle.classList.add('modal-title');
	modalTitle.setAttribute('id', 'normalModalLabel');
	modalTitle.textContent = 'Selection Added';
	modalHeader.appendChild(modalTitle);

	//Creates the close x in upper right of the modal
	let modalCloseButton = document.createElement('button');
	modalCloseButton.setAttribute('type', 'button');
	modalCloseButton.classList.add('close');
	modalCloseButton.setAttribute('aria-label', 'Close');
	modalCloseButton.addEventListener('click', closeModal);
	modalHeader.appendChild(modalCloseButton);
	let modalSpan = document.createElement('span');
	modalSpan.setAttribute('aria-hidden', 'true');
	modalSpan.innerHTML = '&times;';
	modalCloseButton.appendChild(modalSpan);

	//Text content area of modal
	let modalBody = document.createElement('div');
	modalBody.classList.add('modal-body');
	modalBody.textContent = 'Your selection was added to your order!!';
	modalContent.appendChild(modalBody);

	//Modal footer
	let modalFooter = document.createElement('div');
	modalFooter.classList.add('modal-footer');
	modalContent.appendChild(modalFooter);

	//Creates checkout button
	let modalCheckoutButton = document.createElement('button');
	modalCheckoutButton.setAttribute('id', 'checkOut')
	modalCheckoutButton.setAttribute('type', 'button');
	modalCheckoutButton.classList.add('button');
	modalCheckoutButton.classList.add('badge-pill');
	modalCheckoutButton.classList.add('badge-secondary');
	modalCheckoutButton.classList.add('ml-3');
	modalCheckoutButton.textContent = 'Checkout';
	modalCheckoutButton.addEventListener('click', function(){
		window.location.href= "/orders/"+ activeOrder+'/check_out'
	} );
	modalFooter.appendChild(modalCheckoutButton);

	//creates Add More items button
	let modalAddButton = document.createElement('button');
	modalAddButton.setAttribute('id', 'addItem');
	modalAddButton.setAttribute('type', 'button');
	modalAddButton.classList.add('button');
	modalAddButton.classList.add('badge-pill');
	modalAddButton.classList.add('badge-primary');
	modalAddButton.classList.add('ml-3');
	modalAddButton.classList.add('modifier-product');
	modalAddButton.textContent = 'Add more items';
	modalAddButton.addEventListener('click', function(){
		closeModal();

	});
	modalFooter.appendChild(modalAddButton);

	//Grabs the parent element of the div container and inserts modal before it.
	demoContainer.parentElement.insertBefore(modal, demoContainer);

	//Opens the modal for user to see
	$("#normalModal").modal('show');
	// };

};

//Function to call the alert modal
function alertModal(alertMessage) {
	let message = alertMessage;
	let mainEleChild = document.getElementsByTagName('MAIN')[0].firstElementChild.id
	let demoContainer = document.getElementById(mainEleChild);
	if ($("#alertModal").length > 0){
		$("#alertModal .modal-body").text(message);
		$("#alertModal").modal('show');
	} else {
		//The following creates the modal
		modal = document.createElement('div');
		modal.classList.add('modal');
		modal.classList.add('fade');
		modal.setAttribute('id', 'alertModal');
		modal.setAttribute('tabindex', '-1');
		modal.setAttribute('role', 'dialog');
		modal.setAttribute('aria-labelledby', 'alertModalLabel');
		let modalDialogArea = document.createElement('div');
		modalDialogArea.classList.add('modal-dialog');
		modalDialogArea.classList.add('modal-dialog-centered');
		modalDialogArea.classList.add('modal-sm');
		modalDialogArea.setAttribute('role', 'document');
		modal.appendChild(modalDialogArea);
		let modalContent = document.createElement('div');
		modalContent.classList.add('modal-content');
		modalDialogArea.appendChild(modalContent);
		let modalHeader = document.createElement('div');
		modalHeader.classList.add('modal-header');
		modalContent.appendChild(modalHeader);
		let modalTitle = document.createElement('h5');
		modalTitle.classList.add('modal-title');
		modalTitle.setAttribute('id', 'exampleModalLabel');
		modalTitle.textContent = 'Attention!';
		modalHeader.appendChild(modalTitle);
		let modalCloseButton = document.createElement('button');
		modalCloseButton.setAttribute('type', 'button');
		modalCloseButton.classList.add('close');
		modalCloseButton.setAttribute('aria-label', 'Close');
		modalCloseButton.addEventListener('click', closeModal);
		modalHeader.appendChild(modalCloseButton);
		let modalSpan = document.createElement('span');
		modalSpan.setAttribute('aria-hidden', 'true');
		modalSpan.innerHTML = '&times;';
		modalCloseButton.appendChild(modalSpan);
		let modalBody = document.createElement('div');
		modalBody.classList.add('modal-body');
		modalBody.textContent = message;
		modalContent.appendChild(modalBody);
		let modalFooter = document.createElement('div');
		modalFooter.classList.add('modal-footer');
		modalContent.appendChild(modalFooter);

		let modalAddButton = document.createElement('button');
		modalAddButton.setAttribute('type', 'button');
		modalAddButton.classList.add('button');
		modalAddButton.classList.add('badge-pill');
		modalAddButton.classList.add('badge-primary');
		modalAddButton.classList.add('ml-3');
		modalAddButton.textContent = 'OK';
		modalAddButton.addEventListener('click', closeModal);
		modalFooter.appendChild(modalAddButton);

		demoContainer.appendChild(modal);

		//Opens the modal for user to see
		$("#alertModal").modal('show');
	}
};

function testModal(alertMessage){
	$( "#dialog" ).dialog();
}

async function showModal($modal_element)
{
	const $send = $('button.send', $modal_element);
	const $hide = $('button.hide', $modal_element);

	return new Promise(resolve => {
		$modal_element.on('shown.bs.modal', function onShow() {
			$modal_element.off('shown.bs.modal', onShow);
			// When the user clicks the "Send" button, close the modal.
			$send.click(function onSend() {
				$send.off('click', onSend);
				$modal_element.modal('hide');
			});
			// When the user clicks the "Hide" button, clear message and close the modal.
			$hide.click(function onSend() {
				$hide.off('click', onSend);
				$modal_element.modal('hide');
			});
		});

		// Show the modal.
		$modal_element.modal({
			backdrop: 'static',
			focus: true,
			show: true
		});
		$modal_element.modal('show');
	});
}

function stopWatch(startTime, endTime, intervalSeconds, warningSeconds, stopSeconds) {
	var startDateTime = new Date(startTime); //new Date("2024-01-12T20:10:00"); // example start time
	var endDateTime = new Date(endTime); // new Date("2024-01-13T17:00:00"); // example end time
	var intervalTime = intervalSeconds; // 120; // in seconds
	var warningTime = warningSeconds; // 60; // in seconds
	var stopTime = stopSeconds; //15; // in seconds
	var currentState = 'ds-no-light';
	//console.log('stopWatch');
	//var intervalAlarm = new Audio('/storage/media/mixkit-censorship-beep-1082.wav'); // interval alarm sound
	var warningAlarm = new Audio('/storage/media/mixkit-censorship-beep-1082.wav'); // warning alarm sound
	//var stopAlarm = new Audio('/storage/media/331410998.wav'); // stop alarm sound
	var stopAlarm = new Audio('/storage/media/mixkit-feeling-happy-5.mp3'); // stop alarm sound

	function updateClasses() {
		$('.ds-stopwatch').removeClass('ds-green-light ds-yellow-light ds-red-light ds-no-light').addClass(currentState);
	}

	function playWarning() {
		warningAlarm.play();
		warningAlarm.currentTime = 0;
		warningAlarm.loop = false;
	}

	function stopWarning() {
		warningAlarm.pause();
		warningAlarm.currentTime = 0;
		warningAlarm.loop = false;
	}

 	function playStopAlarm() {
		stopAlarm.play();
		stopAlarm.loop = true; // keep playing until interval time
	}

	function stopStopAlarm() {
		stopAlarm.pause();
		stopAlarm.currentTime = 0;
		stopAlarm.loop = false;
	}

	var warningID;
	var currentTime = new Date();
	if (currentTime >= startDateTime && currentTime <= endDateTime) {
		var intervalID = setInterval(function() {
			var now = new Date();
			var timeSinceStart = (now - startDateTime) / 1000; // in seconds
			var timeLeft = intervalTime - timeSinceStart % intervalTime;
			// Start
			if (timeLeft > warningTime && currentState !== 'ds-green-light') {
				//intervalAlarm.play();
				currentState = 'ds-green-light';
				updateClasses();
			}
			// Warning
			if (timeLeft <= warningTime && timeLeft > stopTime && currentState !== 'ds-yellow-light') {
				currentState = 'ds-yellow-light';
				updateClasses();
				//playWarning();
				warningID = setInterval(playWarning, 10000); // play every 10 seconds. 1000 = 1 second
			}
			// Stop
			if (timeLeft <= stopTime) {
				if (currentState !== 'ds-red-light') {
					currentState = 'ds-red-light';
					stopWarning();
					updateClasses();
					clearInterval(warningID);
					playStopAlarm();
				}
			} else {
				stopStopAlarm();
			}

			// End time check
			if (now > endDateTime) {
				currentState = 'ds-red-light';
				updateClasses();
				clearInterval(intervalID);
			}
		}, 1000); // check every second
	}
}

function resetWatch($resetButton, $watchButton) {
	let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
	let productID = $resetButton.attr('data-product_id');
	let targetUrl = '/products/'+ productID + '/resetWatch';
	$.ajax(
		{
			/* the route pointing to the post function */
			url: targetUrl,
			type: 'GET',
			/* send the csrf-token and the input to the controller */
			data: {
				_token: CSRF_TOKEN,
			},
			dataType: 'json',
			/* remind that 'data' is the response of the AjaxController */
			success: function (data, textStatus, jqXHR) {
				//console.log(jqXHR);
				if (data.status == 'error') {
					// Darby.alertModal(data.message);
					console.log(data.message);
				} else {
					console.log(data.message);
					$resetButton.text(data.html);
					$watchButton.attr('data-start_time', data.start_time);
					//$('.spots[data-product_id="'+product_id+'"][data-entity_id="'+entity_id+'"][data-rounds="'+rounds+'"]').html(data.html);
				}
			},
			error: function (jqXHR, textStatus, errorThrown) {
				// Darby.alertModal('Code Problem');
				console.log(textStatus);
				console.log(errorThrown);
			}
		}
	); // END AJAX
}

export {alertModal, showModal, testModal, stopWatch, resetWatch};

	//**************  END MODAL CODE    ***************************** */

